import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Zap, FileText, TrendingUp } from 'lucide-react';

export const SSGStatusWidget = () => {
  return (
    <Card>
      <CardContent className="py-4 space-y-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Zap className="h-5 w-5 text-primary" />
            <h3 className="font-semibold">SSG Performance</h3>
          </div>
          <Badge variant="default" className="bg-green-500">
            Active
          </Badge>
        </div>

        <div className="grid grid-cols-2 gap-3">
          <div className="space-y-1">
            <div className="text-2xl font-bold text-primary">927</div>
            <div className="text-sm text-muted-foreground">Modules Pre-rendered</div>
          </div>

          <div className="space-y-1">
            <div className="text-2xl font-bold text-primary">&lt;200ms</div>
            <div className="text-sm text-muted-foreground">Load Time</div>
          </div>

          <div className="space-y-1">
            <div className="text-2xl font-bold text-primary">99%</div>
            <div className="text-sm text-muted-foreground">Cache Hit Rate</div>
          </div>

          <div className="space-y-1">
            <div className="text-2xl font-bold text-primary">
              <TrendingUp className="h-6 w-6 inline" />
            </div>
            <div className="text-sm text-muted-foreground">Instant Nav</div>
          </div>
        </div>

        <div className="flex items-center gap-2 text-sm text-muted-foreground pt-2 border-t">
          <FileText className="h-4 w-4" />
          <span>Static HTML delivery via Edge CDN</span>
        </div>

        <div className="text-center py-2">
          <p className="text-xs text-muted-foreground">
            ⚡ World-class performance matching Coursera/Udemy
          </p>
        </div>
      </CardContent>
    </Card>
  );
};
